module.exports = __webpack_public_path__ + "static/media/arrow-alt-left.f79f67ba.svg";